import { defineComponent as _defineComponent } from 'vue'
import { AlgoliaWorkOrder, Project, WorkOrder, WORK_ORDER_STATES } from '@newmoon-org/types';
import { ref } from 'vue';
import { useRouter } from 'vue-router/composables';
import { DialogProgrammatic } from 'buefy';
import { get, pick } from 'lodash';

import { formatDate } from '@/service/dateFormatting.service';
import WorkOrderService from '@/service/workorders.service';

import SearchList from '../list/searchList.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectWorkAssignments',
  props: {
    project: null
  },
  setup(__props: any) {

const props = __props as {
  project: Project;
}

const router = useRouter();



const isLoading = ref<boolean>(false);

const defaultFilters = ref<string>(`projectId:${props.project.id} AND isImported:false AND deleted:false`);
const facets = ref<Array<{ facet: string; displayName: string }>>([
  {
    facet: 'state',
    displayName: 'State',
  },
]);

const actions = ref<
  Array<{
    icon: string;
    click: (item) => Promise<void>;
    classes?: string[];
  }>
>([
  {
    icon: 'edit',
    click: async item => {
      const workOrder = item as AlgoliaWorkOrder;
      goToWorkOrder(workOrder.objectID);
    },
    classes: ['is-primary', 'is-small'],
  },
  {
    icon: 'copy',
    click: async item => {
      await duplicateWorkOrder(item);
    },
    classes: ['is-small'],
  },
]);

function getDate(date: number) {
  return formatDate(date);
}

function getMlhValue(items: any) {
  return items.map(wo => ({
    ...wo,
    mlhValue: WorkOrderService.computeWorkAssignmentMLH(wo).toFixed(1),
  }));
}

async function createWorkOrder() {
  let projectId = props.project.id;
  const workOrder = (await WorkOrderService.create(
    {
      project: {
        id: projectId,
        code: props.project.code,
      },
      authorizationContact: get(props.project.customer, 'contacts[0]', {}),
      isPrevailingWage: props.project?.isPrevailingWage,
      isCashout: props.project?.isCashout,
      customer: {
        ...pick(props.project.customer, ['id', 'name', 'displayAsName']),
      },
      company: props.project.company,
      costCodes: [],
      state: WORK_ORDER_STATES.PLANNED,
    },
    { createWorkOrderNumber: true }
  )) as WorkOrder;

  goToWorkOrder(workOrder.id);
}

async function duplicateWorkOrder(item: AlgoliaWorkOrder): Promise<void> {
  const { result } = await DialogProgrammatic.confirm({
    message: `Are you sure you want to copy WA#${item.workOrderNumber}?`,
    closeOnConfirm: true,
    confirmText: 'Copy',
    type: 'is-warning',
  });
  if (!result) return;

  const woCopy = (await WorkOrderService.createCopyForProject(item.objectID)) as WorkOrder;
  await goToWorkOrder(woCopy.id);
}

async function goToWorkOrder(workOrderId: string): Promise<void> {
  const routeParams = {
    name: 'project-work-order-edit',
    params: {
      projectId: props.project.id,
      workOrderId,
    },
  };
  await router.push(routeParams);
}

return { __sfc: true,router, props, isLoading, defaultFilters, facets, actions, getDate, getMlhValue, createWorkOrder, duplicateWorkOrder, goToWorkOrder, SearchList }
}

})